<template>
  <div class="news">
    <div class="all-title">
      {{pageData.title}}
    </div>
    <div class="news-box">
      <newsList></newsList>
      <div class="prev-next">
        <span class="prev" @click="reduction()" v-if="page >= 2">&lt;</span>
        <em v-if="allpage >= page && allpage > 1">{{page}}</em>
        <span class="next" @click="add()" v-if="page < allpage">&gt;</span>
      </div>
    </div>
  </div>
</template>
<script>
  import newsList from '../components/newsList.vue';
  export default{
    data(){
      return{
        resDatas:'',
        num:'',
        page:1,
        allpage:''
      }
    },
    components:{
      newsList
    },
    computed: {
      pageData() {
        this.num=this.$store.state.languagesData.news.num;
        return this.$store.state.languagesData.news;
      }
    },
    props: {
        resData: {}
    },
    watch: {
        resData(newData){
          this.resDatas=newData;
        }
    },
    methods:{
      add(){
        this.$children[0].adds();
        this.page=this.page+1;
      },
      reduction(){
        this.$children[0].reductions();
        this.page=this.page-1;
      }
    },
    mounted() {
      this.allpage=this.$children[0].page;
      this.$store.commit("highLighted",this.$route.name);
    }
  }
</script>

<style scoped>
  .news-box{
    max-width: 750px;
    margin: auto;
  }
  .title{
    font-size: 20px;
    font-weight: 600;
    color: #57749C;
    padding: 2% 3%;
    border-bottom: 1px solid #57749C;
  }
  .product-main{

  }
  .product-banner{
    padding: 2%;
  }
  .product-banner img{
    width: 100%;
    display: block;
  }
  .product-text{
    font-size: 16px;
    word-break: break-all;
  }
  .product-download{
    background-color: #E7EBF1;
    padding: 1.5% 2%;
    margin-top: 1%;
  }
  .product-download .download-title{
    color: #5B6E88;
    font-size: 20px;
    text-align: center;
    background-color: white;
    padding: 1% 0;
    font-weight: 600;
  }
  .download-box{
      font-size: 0;
      text-align: center;
  }
  .download-box a{
    display: inline-block;
    cursor: pointer;
    width: 15%;
    margin: 1% 1% 0;
  }
  .download-box a img{
    width: 100%;
    display: block;
  }
  .prev-next{
    margin-top: 3%;
    text-align: center;
  }
  .prev-next::after{
    content: '';
    clear: both;
    display: block;
  }
  .prev-next span,.prev-next em{
    cursor: pointer;
    padding: 1%;
    /* background-color: #536E7A; */
    color: black;
    border: 1px solid #536E7A;
    transition: all .3s
  }
  .prev-next em{
    cursor: auto;
  }
  .prev-next span:hover{
    background-color: #536E7A;
    color: white;
  }
  .prev{
    /* float: left; */
  }
  .next{
    /* float: right; */
  }
  @media screen and (max-width: 1000px){
    .news-box{
      width: 94%;
    }
    .news-box{
      margin-top: 5%;
    }
    .product-download{
      padding: 3%;
    }
    .download-box a{
      margin: 3% 3% 0;
      width: 34%;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/news.vue